import { User } from './auth.models';
import { Address } from './core.models';
import { Currency as CurrencyModel } from './currency.models';
import { Establishment } from './establishment.model';
import { BillingType } from './invoice.models';
import { Organization } from './organization.models';
import { FreeRequestParams } from './shared.models';

export enum CustomerSupplierType {
  bToB = 'BtoB',
  bToC = 'BtoC',
  bToG = 'BtoG',
  bToF = 'BtoF'
}

export enum Currency {
  xof = 'XOF',
  usd = 'USD',
  eur = 'EUR'
}

export enum Kind {
  customer = 'customer',
  supplier = 'supplier'
}

export type LegalType = 'company' | 'individual';

export type CustomerSupplier = {
  id: string;
  idu?: string;
  name: string;
  email: string;
  taxSystem: string;
  activity: string;
  phoneNumber: string;
  ntd: string;
  billingType: BillingType;
  nif: string;
  taxRegime?: string;
  taxCenter?: string;
  organization?: Organization;
  organizationId?: string;
  type: BillingType;
  billingCurrency: Currency;
  billingAddressName?: string;
  kind?: Kind;
  country?: string;
  city?: string;
  location?: string;
  zipcode?: string;
  district?: string;
  billingAddresses: BillingAddress[];
  createdBy?: Organization;
  createdAt: string;
  updatedAt: string;
  legalType?: LegalType;
  activitySector?: string;
  statusLabel?: string;
};

export type BillingAddress = {
  id?: string;
  name: string;
  address: Address;
  phoneNumber: string;
  email: string;
  establishment: Establishment;
  createdBy: Organization;
  enabled: boolean;
};

export type ListCustomerSupplierRequestParams = FreeRequestParams & {
  nif?: string;
  name?: string;
  email?: string;
  phoneNumber?: string;
  organizationId?: string;
  billingType?: CustomerSupplierType | BillingType;
  type?: CustomerSupplierType | BillingType;
  billingCurrency?: Currency;
  createdById?: string;
  createdAt?: string;
  updatedAt?: string;
};

export type CreateCustomerSupplierParams = {
  name: string;
  email?: string;
  phoneNumber?: string;
  ntd?: string;
  nif?: string;
  taxSystem?: string;
  taxCenter?: string;
  organizationId: string;
  type: CustomerSupplierType;
  billingCurrency?: Currency;
  legalType?: 'individual' | 'company';
};

export type BillingAddressFormValue = {
  phoneNumber: string;
  address: {
    country: string;
    city: string;
    district: string;
    location: string;
    currency?: CurrencyModel;
    zipcode: string;
  };
  email?: string;
  name?: string;
};

export type UpdateCustomerSupplierParams =
  Partial<CreateCustomerSupplierParams>;
